var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V5.5C1.5 6.05228 1.94772 6.5 2.5 6.5H5.5C6.05228 6.5 6.5 6.05228 6.5 5.5V2.5C6.5 1.94772 6.05228 1.5 5.5 1.5Z",
    stroke: "#4E81F4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.5H10.5C9.94772 1.5 9.5 1.94772 9.5 2.5V5.5C9.5 6.05228 9.94772 6.5 10.5 6.5H13.5C14.0523 6.5 14.5 6.05228 14.5 5.5V2.5C14.5 1.94772 14.0523 1.5 13.5 1.5Z",
    stroke: "#4E81F4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5H2.5C1.94772 9.5 1.5 9.94772 1.5 10.5V13.5C1.5 14.0523 1.94772 14.5 2.5 14.5H5.5C6.05228 14.5 6.5 14.0523 6.5 13.5V10.5C6.5 9.94772 6.05228 9.5 5.5 9.5Z",
    stroke: "#4E81F4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5H10.5C9.94772 9.5 9.5 9.94772 9.5 10.5V13.5C9.5 14.0523 9.94772 14.5 10.5 14.5H13.5C14.0523 14.5 14.5 14.0523 14.5 13.5V10.5C14.5 9.94772 14.0523 9.5 13.5 9.5Z",
    stroke: "#4E81F4",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfInfoIcon);
export default __webpack_public_path__ + "static/media/profInfoIcon.419209321a37f5740d34649d94d06cfa.svg";
export { ForwardRef as ReactComponent };